import {
  Dialog,
  Text,
  TextHighlight,
  TextWeight
} from '@focaldata/cin-ui-components'
import React from 'react'

interface Props {
  isOpen: boolean
  toggleOpenDialog: (open: boolean) => void
  onEndProject: () => void
  // What the dialog ends — 'project' for single-market projects, 'market'
  // when ending a single market of a multi-market project.
  entity?: 'project' | 'market'
  // Shows the primary button as busy while the end is in flight.
  isSubmitting?: boolean
}

const getMainText = (entity: string) => `End ${entity}?`
const getGeneralExplanation = (entity: string) =>
  `This will bring the ${entity} to an end.`

const getAdditionalExplanation = (entity: string) =>
  `You will not be able to restart the ${entity} after ending it. Please note that the final number of completes may be lower than the current number after any outstanding data quality checks have completed.`

const DialogEndProject: React.FC<Props> = (props: Props) => {
  const {
    isOpen,
    toggleOpenDialog,
    onEndProject,
    entity = 'project',
    isSubmitting = false
  }: Props = props
  return (
    <Dialog
      open={isOpen}
      onClickOutside={() => toggleOpenDialog(false)}
      onClose={() => toggleOpenDialog(false)}
      title={getMainText(entity)}
      primaryButtonText={getMainText(entity)}
      primaryButtonClick={onEndProject}
      primaryButtonLoading={isSubmitting}
      primaryButtonDisabled={isSubmitting}
    >
      <Text weight={TextWeight.SemiBold} gutterBottom>
        {getGeneralExplanation(entity)}
      </Text>
      <Text highlight={TextHighlight.Background}>
        {getAdditionalExplanation(entity)}
      </Text>
    </Dialog>
  )
}

export default DialogEndProject
